import {useEffect} from 'react';
import {Link} from "react-router-dom"


export function Logout ({auth, handleLogout}) {

    useEffect(()=>{
	    if (auth.nom) {
	      handleLogout();
	    }
  },[])

  return (
    <div><br/>
    	<div className="success" style={{width:'50%'}}>
	    	<br/><br/>
	    	Vous avez bien été déconnecté.
	    	<br/><br/><br/>
	    	<Link to="/automaths" title="Automaths" className="btn standard">Retour</Link>
	    	<br/><br/><br/>
			</div>
    </div>
  );
}